import React from "react";
import { element, oneOfType, string } from "prop-types";
import styles from "./styles/NoData.module.css";
import { Card, Stack } from "react-bootstrap";
import { ReactComponent as Nodata } from "@assets/svgs/no_data.svg";
import clsx from "clsx";

const NoData = ({ className, title, message }) => {
  return (
    <Card body className={clsx(styles.container, "p-5", className)}>
      <Stack className="align-items-center" gap={4}>
        <div className="border p-5 rounded-circle">
          <Nodata width={120} height={120} />
        </div>
        <div>
          <h5 className="text-center">{title}</h5>
          {message && <p className="text-center text-muted">{message}</p>}
        </div>
      </Stack>
    </Card>
  );
};

/* required: display name */
NoData.displayName = "NoData";

/* required: props types */
NoData.propTypes = {
  title: oneOfType([string, element]),
  message: oneOfType([string, element]),

  className: string,
};

/* required: default props */
NoData.defaultProps = {
  title: "No Data Found!",
  message: "",
};

export { NoData };
